import type { Template } from "@/types";

export const LA_07_H5_V2: Template[] = [
{
    id: "la-07-h5v2-01",
    name: "LA 01 - H5V2",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h5_v2_01.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 90, y: 47, width: 193, height: 123, rotation: 0, imageRotation: 0 },
            { id: "2", x: 90, y: 177, width: 193, height: 123, rotation: 0, imageRotation: 0 },
            { id: "3", x: 90, y: 307, width: 193, height: 123, rotation: 0, imageRotation: 0 },
            { id: "4", x: 291, y: 47, width: 256, height: 385, rotation: 0, imageRotation: 0 },
            { id: "5", x: 717, y: 77, width: 235, height: 158, rotation: 0, imageRotation: 0 },
            { id: "6", x: 717, y: 242, width: 235, height: 158, rotation: 0, imageRotation: 0 },
            { id: "7", x: 959, y: 77, width: 236, height: 322, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h5v2-02",
    name: "LA 02 - H5V2",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h5_v2_02.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 89, y: 39, width: 260, height: 397, rotation: 0, imageRotation: 0 },
            { id: "2", x: 356, y: 39, width: 193, height: 126, rotation: 0, imageRotation: 0 },
            { id: "3", x: 356, y: 173, width: 193, height: 263, rotation: 0, imageRotation: 0 },
            { id: "4", x: 712, y: 40, width: 486, height: 275, rotation: 0, imageRotation: 0 },
            { id: "5", x: 712, y: 323, width: 157, height: 113, rotation: 0, imageRotation: 0 },
            { id: "6", x: 877, y: 323, width: 157, height: 113, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1042, y: 323, width: 156, height: 113, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h5v2-03",
    name: "LA 03 - H5V2",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h5_v2_03.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 120, y: 47, width: 392, height: 195, rotation: 0, imageRotation: 0 },
            { id: "2", x: 120, y: 249, width: 253, height: 180, rotation: 0, imageRotation: 0 },
            { id: "3", x: 381, y: 249, width: 131, height: 180, rotation: 0, imageRotation: 0 },
            { id: "4", x: 727, y: 47, width: 256, height: 385, rotation: 0, imageRotation: 0 },
            { id: "5", x: 990, y: 47, width: 193, height: 124, rotation: 0, imageRotation: 0 },
            { id: "6", x: 990, y: 177, width: 193, height: 123, rotation: 0, imageRotation: 0 },
            { id: "7", x: 990, y: 308, width: 193, height: 123, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h5v2-04",
    name: "LA 04 - H5V2",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h5_v2_04.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 154, y: 56, width: 179, height: 118, rotation: 0, imageRotation: 0 },
            { id: "2", x: 154, y: 180, width: 179, height: 118, rotation: 0, imageRotation: 0 },
            { id: "3", x: 154, y: 306, width: 179, height: 117, rotation: 0, imageRotation: 0 },
            { id: "4", x: 340, y: 56, width: 248, height: 367, rotation: 0, imageRotation: 0 },
            { id: "5", x: 596, y: 56, width: 249, height: 367, rotation: 0, imageRotation: 0 },
            { id: "6", x: 852, y: 56, width: 270, height: 180, rotation: 0, imageRotation: 0 },
            { id: "7", x: 852, y: 243, width: 270, height: 179, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h5v2-05",
    name: "LA 05 - H5V2",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h5_v2_05.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 154, y: 56, width: 179, height: 118, rotation: 0, imageRotation: 0 },
            { id: "2", x: 154, y: 180, width: 179, height: 118, rotation: 0, imageRotation: 0 },
            { id: "3", x: 154, y: 306, width: 179, height: 117, rotation: 0, imageRotation: 0 },
            { id: "4", x: 340, y: 56, width: 248, height: 367, rotation: 0, imageRotation: 0 },
            { id: "5", x: 596, y: 56, width: 270, height: 180, rotation: 0, imageRotation: 0 },
            { id: "6", x: 596, y: 243, width: 270, height: 179, rotation: 0, imageRotation: 0 },
            { id: "7", x: 873, y: 56, width: 249, height: 367, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h5v2-06",
    name: "LA 06 - H5V2",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h5_v2_06.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 26, y: 56, width: 542, height: 367, rotation: 0, imageRotation: 0 },
            { id: "2", x: 576, y: 56, width: 123, height: 180, rotation: 0, imageRotation: 0 },
            { id: "3", x: 576, y: 243, width: 268, height: 179, rotation: 0, imageRotation: 0 },
            { id: "4", x: 707, y: 56, width: 268, height: 180, rotation: 0, imageRotation: 0 },
            { id: "5", x: 851, y: 243, width: 268, height: 179, rotation: 0, imageRotation: 0 },
            { id: "6", x: 982, y: 56, width: 268, height: 180, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1126, y: 243, width: 123, height: 179, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h5v2-07",
    name: "LA 07 - H5V2",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h5_v2_07.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 26, y: 56, width: 542, height: 367, rotation: 0, imageRotation: 0 },
            { id: "2", x: 576, y: 56, width: 123, height: 180, rotation: 0, imageRotation: 0 },
            { id: "3", x: 576, y: 243, width: 123, height: 179, rotation: 0, imageRotation: 0 },
            { id: "4", x: 707, y: 56, width: 268, height: 180, rotation: 0, imageRotation: 0 },
            { id: "5", x: 707, y: 243, width: 268, height: 179, rotation: 0, imageRotation: 0 },
            { id: "6", x: 982, y: 56, width: 268, height: 180, rotation: 0, imageRotation: 0 },
            { id: "7", x: 982, y: 243, width: 268, height: 179, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h5v2-08",
    name: "LA 08 - H5V2",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h5_v2_08.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 26, y: 56, width: 542, height: 367, rotation: 0, imageRotation: 0 },
            { id: "2", x: 576, y: 56, width: 268, height: 180, rotation: 0, imageRotation: 0 },
            { id: "3", x: 576, y: 243, width: 268, height: 179, rotation: 0, imageRotation: 0 },
            { id: "4", x: 851, y: 56, width: 267, height: 180, rotation: 0, imageRotation: 0 },
            { id: "5", x: 851, y: 243, width: 267, height: 179, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1125, y: 56, width: 124, height: 180, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1125, y: 243, width: 124, height: 179, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h5v2-09",
    name: "LA 09 - H5V2",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h5_v2_09.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 57, y: 62, width: 314, height: 201, rotation: 0, imageRotation: 0 },
            { id: "2", x: 57, y: 269, width: 206, height: 147, rotation: 0, imageRotation: 0 },
            { id: "3", x: 271, y: 269, width: 207, height: 147, rotation: 0, imageRotation: 0 },
            { id: "4", x: 379, y: 62, width: 315, height: 201, rotation: 0, imageRotation: 0 },
            { id: "5", x: 486, y: 269, width: 207, height: 147, rotation: 0, imageRotation: 0 },
            { id: "6", x: 701, y: 62, width: 253, height: 355, rotation: 0, imageRotation: 0 },
            { id: "7", x: 962, y: 62, width: 254, height: 355, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h5v2-10",
    name: "LA 10 - H5V2",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h5_v2_10.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 57, y: 60, width: 254, height: 355, rotation: 0, imageRotation: 0 },
            { id: "2", x: 319, y: 60, width: 253, height: 355, rotation: 0, imageRotation: 0 },
            { id: "3", x: 580, y: 214, width: 315, height: 201, rotation: 0, imageRotation: 0 },
            { id: "4", x: 903, y: 214, width: 314, height: 201, rotation: 0, imageRotation: 0 },
            { id: "5", x: 580, y: 60, width: 207, height: 147, rotation: 0, imageRotation: 0 },
            { id: "6", x: 795, y: 60, width: 207, height: 147, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1010, y: 60, width: 206, height: 147, rotation: 0, imageRotation: 0 }
    ],
}
];